import React, {Component} from 'react';
type boundaryProps = {
    children: any;
}

type boundaryState = {
    hasError: Boolean;
}

class ErrorBoundary extends Component<boundaryProps,boundaryState> {
    constructor(props:any) {
        super(props);
        this.state  = {
            hasError: false
        }
    }

    static getDerivedStateFromError(error:any) {
        return {
            hasError: true
        }
    }

    componentDidCatch(error:any,info:any) {
        console.log(error,info);
    }

    render() {
        if(this.state.hasError) {
            return <h5 className='text-white'>Something went wrong</h5>
        } 
        return this.props.children
    }
}

export default ErrorBoundary;